module.exports = __webpack_public_path__ + "img/32RED.ade2539c.svg";